/**
 * @file Purchase PPD Checkout Success container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import get from 'lodash.get';

import { AlbumDataWithParentAndSubscription } from '../../graphql/queries/albums';
import PurchasePpdCheckoutSuccess from '../../components/purchase/PurchasePpdCheckoutSuccess';
import { MeWithPurchasedAlbumPrintsByAlbum } from '../../graphql/queries/account';
import { ORDER_STATUS } from '../../constants/pro-custom-prints';

const withAlbumData = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album } }) => ({
    album,
  }),
});

const withCustomerInputPurchasedCustomPrints = graphql(
  MeWithPurchasedAlbumPrintsByAlbum,
  {
    options: ({ match }) => ({
      variables: {
        albumId: match.params.albumId,
        orderStatuses: [ORDER_STATUS.CUSTOMER_INPUT],
      },
      fetchPolicy: 'cache-and-network',
    }),
    props: ({ data: { me } }) => ({
      pendingPurchasedCustomPrints: get(
        me,
        'purchased_custom_prints.records',
        [],
      ),
    }),
    skip: ({ match }) => !match.params.albumId,
  },
);

const mapStateToProps = ({ ppdPurchase }) => ({
  purchasedItems: ppdPurchase.purchasedItems,
});

export default compose(
  withRouter,
  withAlbumData,
  withCustomerInputPurchasedCustomPrints,
  connect(mapStateToProps),
)(PurchasePpdCheckoutSuccess);
